
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface PCComponent {
  id: string;
  name: string;
  category: string;
  price: number;
  image: string;
  brand: string;
  specs?: string;
}

const components: Record<string, PCComponent[]> = {
  processor: [
    {
      id: 'cpu1',
      name: 'Intel Core i9-14900K',
      category: 'Processador',
      price: 3499.99,
      image: 'https://public.readdy.ai/ai/img_res/529a12419c9c86af5ccb2d5d9aaa67b3.jpg',
      brand: 'Intel',
      specs: '24 núcleos, 32 threads, 6.0GHz'
    },
    {
      id: 'cpu2',
      name: 'AMD Ryzen 9 7950X',
      category: 'Processador',
      price: 3299.99,
      image: 'https://readdy.ai/api/search-image?query=AMD%20Ryzen%209%20processor%20CPU%20chip%20product%20photography%20on%20clean%20white%20background%20with%20studio%20lighting%20showing%20the%20orange%20AMD%20branding%20and%20modern%20design%20professional%20product%20shot&width=300&height=300&seq=cpu2&orientation=squarish',
      brand: 'AMD',
      specs: '16 núcleos, 32 threads, 5.7GHz'
    }
  ],
  motherboard: [
    {
      id: 'mb1',
      name: 'ASUS ROG Maximus Z790',
      category: 'Placa-Mãe',
      price: 2199.99,
      image: 'https://readdy.ai/api/search-image?query=Gaming%20motherboard%20Z790%20product%20photography%20on%20white%20background%20with%20studio%20lighting%20showing%20the%20black%20PCB%20with%20RGB%20lighting%20zones%20multiple%20PCIe%20slots%20and%20premium%20components%20professional%20product%20shot&width=300&height=300&seq=mb1&orientation=squarish',
      brand: 'ASUS',
      specs: 'ATX, DDR5, PCIe 5.0'
    }
  ],
  gpu: [
    {
      id: 'gpu1',
      name: 'RTX 4090 24GB',
      category: 'Placa de Vídeo',
      price: 12999.99,
      image: 'https://readdy.ai/api/search-image?query=NVIDIA%20RTX%204090%20graphics%20card%20product%20photography%20on%20clean%20white%20background%20with%20soft%20studio%20lighting%20showcasing%20the%20sleek%20black%20and%20silver%20design%20with%20RGB%20lighting%20accents%20and%20premium%20build%20quality%20high%20resolution%20professional%20product%20shot&width=300&height=300&seq=gpu1&orientation=squarish',
      brand: 'NVIDIA',
      specs: '24GB GDDR6X, Ray Tracing'
    },
    {
      id: 'gpu2',
      name: 'RTX 4080 16GB',
      category: 'Placa de Vídeo',
      price: 8999.99,
      image: 'https://readdy.ai/api/search-image?query=NVIDIA%20RTX%204080%20graphics%20card%20product%20photography%20on%20white%20background%20with%20professional%20lighting%20showing%20the%20modern%20black%20design%20with%20RGB%20elements%20high%20quality%20product%20image&width=300&height=300&seq=gpu2&orientation=squarish',
      brand: 'NVIDIA',
      specs: '16GB GDDR6X, Ray Tracing'
    }
  ],
  ram: [
    {
      id: 'ram1',
      name: 'Corsair Vengeance DDR5 32GB',
      category: 'Memória RAM',
      price: 899.99,
      image: 'https://readdy.ai/api/search-image?query=DDR5%20RAM%20memory%20modules%20product%20photography%20on%20clean%20white%20background%20with%20studio%20lighting%20showing%20the%20black%20heat%20spreaders%20and%20RGB%20lighting%20strips%20modern%20gaming%20memory%20sticks%20professional%20product%20shot&width=300&height=300&seq=ram1&orientation=squarish',
      brand: 'Corsair',
      specs: '2x16GB, 6000MHz, RGB'
    }
  ],
  storage: [
    {
      id: 'ssd1',
      name: 'Samsung 990 Pro 2TB',
      category: 'Armazenamento',
      price: 799.99,
      image: 'https://readdy.ai/api/search-image?query=NVMe%20SSD%20solid%20state%20drive%20product%20photography%20on%20white%20background%20with%20professional%20lighting%20showing%20the%20sleek%20black%20design%20with%20copper%20heat%20sink%20and%20PCIe%20connector%20high%20resolution%20commercial%20image&width=300&height=300&seq=ssd1&orientation=squarish',
      brand: 'Samsung',
      specs: 'NVMe PCIe 4.0, 7450MB/s'
    }
  ],
  psu: [
    {
      id: 'psu1',
      name: 'Corsair RM850x',
      category: 'Fonte',
      price: 699.99,
      image: 'https://readdy.ai/api/search-image?query=Modular%20power%20supply%20unit%20850W%20product%20photography%20on%20clean%20white%20background%20with%20studio%20lighting%20showing%20the%20black%20casing%20with%20gold%20certification%20badge%20and%20modular%20cables%20professional%20product%20image&width=300&height=300&seq=psu1&orientation=squarish',
      brand: 'Corsair',
      specs: '850W, 80 Plus Gold, Modular'
    }
  ],
  case: [
    {
      id: 'case1',
      name: 'NZXT H7 Flow',
      category: 'Gabinete',
      price: 599.99,
      image: 'https://readdy.ai/api/search-image?query=Gaming%20PC%20case%20mid%20tower%20with%20tempered%20glass%20panel%20and%20RGB%20lighting%20product%20photography%20on%20white%20background%20showing%20the%20black%20chassis%20with%20colorful%20LED%20strips%20and%20modern%20design%20professional%20studio%20shot&width=300&height=300&seq=case1&orientation=squarish',
      brand: 'NZXT',
      specs: 'Mid Tower, Vidro Temperado'
    }
  ],
  cooler: [
    {
      id: 'cooler1',
      name: 'NZXT Kraken 360',
      category: 'Cooler',
      price: 899.99,
      image: 'https://readdy.ai/api/search-image?query=AIO%20liquid%20CPU%20cooler%20360mm%20with%20RGB%20fans%20product%20photography%20on%20white%20background%20showing%20the%20radiator%20pump%20block%20and%20three%20colorful%20LED%20fans%20professional%20studio%20lighting%20high%20quality%20product%20shot&width=300&height=300&seq=cooler1&orientation=squarish',
      brand: 'NZXT',
      specs: '360mm, RGB, LCD Display'
    }
  ]
};

export default function MonteSeuPCPage() {
  const [selectedComponents, setSelectedComponents] = useState<Record<string, PCComponent | null>>({
    processor: null,
    motherboard: null,
    gpu: null,
    ram: null,
    storage: null,
    psu: null,
    case: null,
    cooler: null
  });

  const [activeCategory, setActiveCategory] = useState<string>('processor');

  const selectComponent = (category: string, component: PCComponent) => {
    setSelectedComponents({
      ...selectedComponents,
      [category]: component
    });
  };

  const removeComponent = (category: string) => {
    setSelectedComponents({
      ...selectedComponents,
      [category]: null
    });
  };

  const totalPrice = Object.values(selectedComponents).reduce(
    (sum, component) => sum + (component?.price || 0),
    0
  );

  const categories = [
    { id: 'processor', name: 'Processador', icon: 'ri-cpu-line' },
    { id: 'motherboard', name: 'Placa-Mãe', icon: 'ri-circuit-board-line' },
    { id: 'gpu', name: 'Placa de Vídeo', icon: 'ri-gamepad-line' },
    { id: 'ram', name: 'Memória RAM', icon: 'ri-database-2-line' },
    { id: 'storage', name: 'Armazenamento', icon: 'ri-hard-drive-line' },
    { id: 'psu', name: 'Fonte', icon: 'ri-plug-line' },
    { id: 'case', name: 'Gabinete', icon: 'ri-computer-line' },
    { id: 'cooler', name: 'Cooler', icon: 'ri-temp-cold-line' }
  ];

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <main className="pt-20">
        <div className="relative bg-gradient-to-r from-pink-600 via-purple-600 to-cyan-600 text-white py-16 overflow-hidden">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <h1 className="text-5xl font-black mb-3 animate-pulse bg-gradient-to-r from-pink-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">
              Monte seu PC Gamer
            </h1>
            <p className="text-xl text-cyan-200 font-semibold">Personalize cada componente do seu setup ideal</p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <div className="bg-gray-900 rounded-xl shadow-2xl border border-pink-500/30 p-6 mb-6">
                <h2 className="text-2xl font-black text-transparent bg-gradient-to-r from-pink-400 to-cyan-400 bg-clip-text mb-6">
                  Selecione os Componentes
                </h2>
                <div className="flex flex-wrap gap-2 mb-6">
                  {categories.map((cat) => (
                    <button
                      key={cat.id}
                      onClick={() => setActiveCategory(cat.id)}
                      className={`px-4 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${
                        activeCategory === cat.id
                          ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-lg shadow-pink-500/50'
                          : 'bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700'
                      }`}
                    >
                      <i className={`${cat.icon} mr-2`}></i>
                      {cat.name}
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {components[activeCategory]?.map((component) => (
                    <div
                      key={component.id}
                      className="bg-gray-800 border border-cyan-500/30 rounded-xl p-4 hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:border-pink-500/50"
                    >
                      <div className="w-full h-40 bg-gray-900 rounded-lg mb-3 overflow-hidden">
                        <img
                          src={component.image}
                          alt={component.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="text-xs text-cyan-400 mb-1 font-bold uppercase tracking-wider">{component.brand}</p>
                      <h3 className="font-bold text-white mb-1">{component.name}</h3>
                      {component.specs && (
                        <p className="text-xs text-gray-400 mb-2 font-semibold">{component.specs}</p>
                      )}
                      <p className="text-xl font-black text-transparent bg-gradient-to-r from-pink-400 to-cyan-400 bg-clip-text mb-3">
                        R$ {component.price.toFixed(2).replace('.', ',')}
                      </p>
                      <button
                        onClick={() => selectComponent(activeCategory, component)}
                        className="w-full bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 text-white py-2 rounded-lg text-sm font-black transition-all shadow-lg shadow-pink-500/50 whitespace-nowrap cursor-pointer"
                      >
                        Adicionar
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-gray-900 rounded-xl shadow-2xl border border-cyan-500/30 p-6 sticky top-24">
                <h2 className="text-2xl font-black text-transparent bg-gradient-to-r from-pink-400 to-cyan-400 bg-clip-text mb-6">
                  Seu PC Personalizado
                </h2>

                <div className="space-y-3 mb-6">
                  {categories.map((cat) => {
                    const component = selectedComponents[cat.id];
                    return (
                      <div
                        key={cat.id}
                        className={`p-3 rounded-lg border transition-all ${
                          component 
                            ? 'border-pink-500/50 bg-gradient-to-r from-pink-900/20 to-purple-900/20 shadow-lg shadow-pink-500/20' 
                            : 'border-gray-700 bg-gray-800'
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex-1">
                            <p className="text-xs text-cyan-400 mb-1 font-bold uppercase tracking-wider">{cat.name}</p>
                            {component ? (
                              <>
                                <p className="font-bold text-sm text-white">{component.name}</p>
                                <p className="text-sm font-black text-pink-400">
                                  R$ {component.price.toFixed(2).replace('.', ',')}
                                </p>
                              </>
                            ) : (
                              <p className="text-sm text-gray-500 font-semibold">Não selecionado</p>
                            )}
                          </div>
                          {component && (
                            <button
                              onClick={() => removeComponent(cat.id)}
                              className="text-red-500 hover:text-red-400 ml-2 cursor-pointer transition-colors"
                            >
                              <i className="ri-close-line text-xl"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="border-t border-gray-700 pt-4 mb-6">
                  <div className="flex justify-between text-lg font-black mb-2">
                    <span className="text-white">Total</span>
                    <span className="text-transparent bg-gradient-to-r from-pink-400 to-cyan-400 bg-clip-text text-2xl">
                      R$ {totalPrice.toFixed(2).replace('.', ',')}
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 font-semibold">em até 12x sem juros</p>
                </div>

                <button
                  disabled={totalPrice === 0}
                  className="w-full bg-gradient-to-r from-pink-600 via-purple-600 to-cyan-600 hover:from-pink-500 hover:via-purple-500 hover:to-cyan-500 text-white py-4 rounded-lg font-black transition-all shadow-lg shadow-pink-500/50 hover:shadow-pink-500/70 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none"
                >
                  Adicionar ao Carrinho
                </button>

                <div className="mt-6 p-4 bg-gradient-to-r from-cyan-900/30 to-purple-900/30 rounded-lg border border-cyan-500/30">
                  <div className="flex items-start">
                    <i className="ri-information-line text-cyan-400 text-xl mr-2 mt-1"></i>
                    <div>
                      <p className="text-sm font-bold text-white mb-1">
                        Verificação de Compatibilidade
                      </p>
                      <p className="text-xs text-gray-300 font-semibold">
                        Todos os componentes selecionados são compatíveis entre si.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
